import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Menu,
  MenuItem,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Select,
  FormControl,
  InputLabel,
  IconButton,
  CircularProgress,
  TextField,
  Alert,
  Link,
} from "@mui/material";
import { Dashboard, People, Description, ArrowDropDown, Close, ArrowBack, School, Computer, EventAvailable } from "@mui/icons-material";
import BookingCalendar from "./BookingCalendar";
import FacultyEventTable from "./FDPEDP/FacultyEventTable";
import StatusCards from "./StatusCard";
import TechCampsTable from "./Certificate/TechCampCertificate";
import CareerTalk_Spoc from "./CareerTalk_spoc";
import RatingDialog from "./FDPRating";
import GetHRIntoCampus from "../../Gethr/GetHRIntoCampus";
import TechCampEventTable from "./FDPEDP/TechCampEventTable";
import AdvanceBook from "./AdvanceBook";
import { BASE_URL } from "../../../services/configUrls";
import AdvanceBookFDPSlots from "./AdvanceBookFDP";
import AdvanceBookTechCampSlots from "./AdvanceBookTechCamp";
import AssignTrainerTab from "./AssignTrainerTab";
import SpocPrerequisitesDocuments from "./SpocPrerequisitesDocuments";

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ p: { xs: 1.5, sm: 2.5, md: 3 } }}>{children}</Box>}
    </div>
  );
}

export default function TabActivity() {
  const [value, setValue] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const location = useLocation();
  const [activeSubTabs, setActiveSubTabs] = useState({ fdp: null, techCamp: null });
  const [modalInstituteBookings, setModalInstituteBookings] = useState(null);
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [hasSkippedDomainModal, setHasSkippedDomainModal] = useState(false);
  const [cameFromEventModal, setCameFromEventModal] = useState(false);
  const [bookingModalType, setBookingModalType] = useState(null);
  const [selectionModalOpen, setSelectionModalOpen] = useState(false);
  const [domainModalOpen, setDomainModalOpen] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [tempDomain, setTempDomain] = useState(null);
  const [domainsList, setDomainsList] = useState([]);
  const [loadingDomains, setLoadingDomains] = useState(false);
  const [selectedType, setSelectedType] = useState('');
  const [fdpVisible, setFdpVisible] = useState(false);
  const [techCampVisible, setTechCampVisible] = useState(false);

  useEffect(() => {
    const fetchVisibility = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        };

        const [techCampRes, fdpRes] = await Promise.all([
          fetch(`${BASE_URL}/event/institute/tech_camp-slots-visibility`, { headers }),
          fetch(`${BASE_URL}/event/institute/fdp-slots-visibility`, { headers }),
        ]);

        if (techCampRes.ok) {
          const techData = await techCampRes.json();
          setTechCampVisible(techData.visible === 1);
        }
        if (fdpRes.ok) {
          const fdpData = await fdpRes.json();
          setFdpVisible(fdpData.visible === 1);
        }
      } catch (error) {
        console.error("Error fetching visibility:", error);
      }
    };

    fetchVisibility();
  }, []);

  const userRole = localStorage.getItem("Authorise");

  const handleBookingClick = (booking) => {
    console.log("Booking clicked:", booking);
  };

  const handleRatingSubmitSuccess = () => {
    console.log("Submit success, refreshing");
    setRefreshKey((prev) => prev + 1);
  };

  const handleEventSelect = async (type, skipDomainModal = false, fromEventModal = false) => {
    setBookingModalType(type);
    setSelectedDomain(null);
    setTempDomain(null);
    setSelectionModalOpen(false);
    setCameFromEventModal(fromEventModal);

    setDomainModalOpen(false);
    setModalInstituteBookings(null);
    setBookingModalOpen(true);
  };

  const handleDomainSelect = (dom) => {
    setSelectedDomain(dom);
    setDomainModalOpen(false);
    setBookingModalOpen(true);
  };

  const bookYourSlotButton = (fdpVisible || techCampVisible) ? (
    <Button
      id="booking-button"
      variant="contained"
      startIcon={<EventAvailable />}
      onClick={() => {
        setBookingModalOpen(true);
      }}
      sx={{
        textTransform: 'none',
        borderRadius: '8px',
        bgcolor: "#4a90e2",
        py: 1,
        px: { xs: 2, sm: 3 },
        width: { xs: "100%", sm: "auto" },
        fontWeight: 600,
        boxShadow: "0 4px 14px 0 rgba(74, 144, 226, 0.39)",
        "&:hover": {
          bgcolor: "#357abd",
          boxShadow: "0 6px 20px rgba(74, 144, 226, 0.23)"
        }
      }}
    >
      Book Your Slot
    </Button>
  ) : null;

  const allTabs = [
    {
      label: "Dashboard",
      icon: <Dashboard sx={{ fontSize: 18 }} />,
      show: userRole !== "dspoc",
      render: () => <StatusCards />,
    },
    {
      label: "Assigned Trainer",
      show: userRole !== "dspoc",
      render: () => <AssignTrainerTab />,
    },
    {
      label: "Tech Camp",
      show: userRole !== "dspoc",
      render: () => (
        <TechCampEventTable
          eventType="tech_camp"
          onBookingClick={handleBookingClick}
          refreshKey={refreshKey}
          activeSubTab={activeSubTabs.techCamp}
          onSubTabChange={(val) => setActiveSubTabs((prev) => ({ ...prev, techCamp: val }))}
          actionButton={techCampVisible ? bookYourSlotButton : null}
        />
      ),
    },
    {
      label: "FDP",
      show: userRole !== "dspoc",
      render: () => (
        <FacultyEventTable
          eventType="fdp"
          onBookingClick={handleBookingClick}
          refreshKey={refreshKey}
          activeSubTab={activeSubTabs.fdp}
          onSubTabChange={(val) => setActiveSubTabs((prev) => ({ ...prev, fdp: val }))}
          actionButton={fdpVisible ? bookYourSlotButton : null}
        />
      ),
    },
    // {
    //   label: "EDP",
    //   show: userRole !== "dspoc",
    //   render: () => (
    //     <FacultyEventTable
    //       eventType="edp"
    //       onBookingClick={handleBookingClick}
    //     />
    //   ),
    // },
    {
      label: "Career Talk",
      show: true,
      render: () => <CareerTalk_Spoc />,
    },
    {
      label: "Get HR Into Campus",
      show: userRole !== "dspoc",
      render: () => <GetHRIntoCampus />,
    },
  ];

  const visibleTabs = allTabs.filter((tab) => tab.show);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get("tab");

    if (tabParam === "career-talk") {
      const index = visibleTabs.findIndex((t) => t.label === "Career Talk");
      if (index !== -1) {
        setValue(index);
      }
    } else if (tabParam === "assign-trainer" || tabParam === "assigned-trainer") {
      const index = visibleTabs.findIndex((t) => t.label === "Assign Trainer");
      if (index !== -1) {
        setValue(index);
      }
    } else if (location.state?.activeTab !== undefined) {
      // Ensure the passed index is within bounds of visible tabs
      if (location.state.activeTab < visibleTabs.length) {
        setValue(location.state.activeTab);
      }
    }
  }, [location, visibleTabs.length]);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{ width: "100%", maxWidth: "1536px", mt: { xs: 1.5, sm: 2.5, md: 4 }, mb: 4, mx: "auto", p: { xs: 1, sm: 2 } }}
    >
      {/* Paid / Free Booking Notice Banner */}
      <Alert
        severity="info"
        sx={{
          mb: 2.5,
          borderRadius: 2,
          fontSize: "0.875rem",
          fontWeight: 500,
          border: "1px solid #bfdbfe",
          bgcolor: "#eff6ff",
          color: "#1e40af",
          "& .MuiAlert-icon": {
            color: "#2563eb",
          },
        }}
      >
        For complementary events, visit the{" "}
        <Link
          component="button"
          variant="body2"
          onClick={() => {
            const index = visibleTabs.findIndex(
              (t) => t.label === "Assigned Trainer"
            );
            if (index !== -1) {
              setValue(index);
            }
          }}
          sx={{
            fontWeight: 700,
            color: "#1d4ed8",
            textDecoration: "underline",
            cursor: "pointer",
            verticalAlign: "baseline",
            "&:hover": { color: "#1e40af" },
          }}
        >
          Assigned Trainer
        </Link>{" "}
        tab to check the available limits and assigned trainer details. 
        <br/>Please check the details and contact the respective trainer directly for further coordination.
      </Alert>

      {/* Zoho-Style Tabs */}
      <Box sx={{ borderBottom: "1px solid #e5e7eb", bgcolor: "white" }}>
        <Tabs
          value={value}
          onChange={handleTabChange}
          aria-label="zoho style tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: "auto",
            "& .MuiTabs-indicator": {
              backgroundColor: "#4a90e2",
              height: 3,
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: { xs: "13px", sm: "14px" },
              fontWeight: 500,
              minHeight: { xs: 44, sm: 48 },
              minWidth: "auto",
              px: { xs: 1.5, sm: 2.5, md: 3 },
              py: { xs: 1, sm: 1.5 },
              color: "#6b7280",
              transition: "all 0.2s ease",
              mr: { xs: 0.5, sm: 1 },
              whiteSpace: "nowrap",
              "&.Mui-selected": {
                color: "#111827",
                fontWeight: 600,
              },
              "&:hover": {
                color: "#374151",
                bgcolor: "#f9fafb",
              },
            },
            "& .MuiTabs-flexContainer": {
              gap: "4px",
            },
          }}
        >
          {visibleTabs.map((tab, index) => (
            <Tab
              key={index}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
            />
          ))}
        </Tabs>
      </Box>

      {/* Booking Dropdown Button Row */}
      {visibleTabs[value]?.label === "Dashboard" && bookYourSlotButton && (
        <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' }, pt: 2, pr: { xs: 2, sm: 4, md: 6 }, pb: { xs: 1, sm: 0 }, bgcolor: "#f9fafb" }}>
          <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
            {bookYourSlotButton}
          </Box>
        </Box>
      )}

      {/* Tab Content */}
      <Box sx={{ bgcolor: "#f9fafb", minHeight: "400px" }}>
        {visibleTabs.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            {tab.render()}
          </TabPanel>
        ))}
      </Box>

      {/* Conditionally render RatingDialog if the FDP tab is active. 
          Assuming FDP tab's label is "FDP" */}
      {visibleTabs[value]?.label === "FDP" && (
        <RatingDialog onSubmitSuccess={handleRatingSubmitSuccess} />
      )}

      {/* 1. Event Selection Modal */}
      <Dialog
        open={selectionModalOpen}
        onClose={() => setSelectionModalOpen(false)}
        PaperProps={{ sx: { width: { xs: '92vw', sm: '380px' }, maxWidth: '380px', borderRadius: '16px', p: { xs: 1.5, sm: 2 }, textAlign: 'center', position: 'relative', boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.2)' } }}
      >
        <IconButton
          onClick={() => setSelectionModalOpen(false)}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: 'text.secondary',
            bgcolor: '#f1f5f9',
            '&:hover': { bgcolor: '#e2e8f0', color: '#0f172a' }
          }}
        >
          <Close />
        </IconButton>
        <DialogTitle sx={{ fontWeight: '800', pb: 2, pt: 2, fontSize: '1.25rem', color: '#1e293b' }}>
          Select Event
        </DialogTitle>

        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, pt: 1, pb: 3, px: 2, overflowY: 'visible' }}>
          {fdpVisible && (
            <Button
              onClick={() => handleEventSelect('fdp', true, true)}
              sx={{
                width: '100%',
                py: 1.5,
                borderRadius: '12px',
                border: '2px solid #e2e8f0',
                background: 'linear-gradient(to bottom, #ffffff, #f8fafc)',
                color: '#1e293b',
                boxShadow: '0 2px 4px -1px rgba(0,0,0,0.05)',
                textTransform: 'none',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                display: 'flex',
                flexDirection: 'column',
                '&:hover': {
                  borderColor: '#4f46e5',
                  background: 'linear-gradient(to bottom, #ffffff, #eef2ff)',
                  color: '#4f46e5',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 16px -4px rgba(79, 70, 229, 0.25)'
                }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <School sx={{ fontSize: 16, color: '#4f46e5' }} />
                <Typography sx={{ fontWeight: '700', fontSize: '16px', letterSpacing: '0.3px' }}>
                  FDP
                </Typography>
              </Box>
              <Typography sx={{ fontWeight: '600', fontSize: '12px', opacity: 0.7 }}>
                Faculty Development Program
              </Typography>
            </Button>
          )}

          {techCampVisible && (
            <Button
              onClick={() => handleEventSelect('techCamp', true, true)}
              sx={{
                width: '100%',
                py: 1.5,
                borderRadius: '12px',
                border: '2px solid #e2e8f0',
                background: 'linear-gradient(to bottom, #ffffff, #f8fafc)',
                color: '#1e293b',
                boxShadow: '0 2px 4px -1px rgba(0,0,0,0.05)',
                textTransform: 'none',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                display: 'flex',
                flexDirection: 'column',
                '&:hover': {
                  borderColor: '#059669',
                  background: 'linear-gradient(to bottom, #ffffff, #ecfdf5)',
                  color: '#059669',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 16px -4px rgba(5, 150, 105, 0.25)'
                }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Computer sx={{ fontSize: 16, color: '#059669' }} />
                <Typography sx={{ fontWeight: '700', fontSize: '16px', letterSpacing: '0.3px' }}>
                  Tech Camp
                </Typography>
              </Box>
              <Typography sx={{ fontWeight: '600', fontSize: '12px', opacity: 0.7 }}>
                Technical Training Camp
              </Typography>
            </Button>
          )}
        </DialogContent>
      </Dialog>

      {/* 2. Domain Selection Modal */}
      <Dialog
        open={domainModalOpen}
        onClose={() => setDomainModalOpen(false)}
        PaperProps={{ sx: { width: { xs: '95vw', sm: '500px' }, maxWidth: '500px', borderRadius: '12px', p: { xs: 2, sm: 3 }, position: 'relative' } }}
      >
        <IconButton
          onClick={() => {
            setDomainModalOpen(false);
            setSelectionModalOpen(true);
          }}
          sx={{
            position: 'absolute',
            left: 12,
            top: 12,
            color: 'text.secondary',
            zIndex: 1,
          }}
        >
          <ArrowBack />
        </IconButton>
        <IconButton
          onClick={() => setDomainModalOpen(false)}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: 'text.secondary',
            zIndex: 1,
          }}
        >
          <Close />
        </IconButton>
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', pt: 1, pb: 3, fontSize: '1.25rem' }}>Select Domain</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 0, overflowY: 'visible' }}>
          {loadingDomains ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
              <CircularProgress size={32} />
            </Box>
          ) : domainsList.length > 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <TextField
                select
                label="Select Domain"
                value={tempDomain ? (tempDomain.domain_id || tempDomain.id).toString() : ""}
                onChange={(e) => {
                  const domId = e.target.value.toString();
                  const dom = domainsList.find(d => (d.domain_id || d.id).toString() === domId);
                  if (dom) setTempDomain(dom);
                }}
                sx={{
                  minWidth: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                    "& fieldset": {
                      borderColor: "#cbd5e1",
                      borderWidth: "1.5px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#94a3b8",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2563eb",
                      borderWidth: "2px",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#64748b",
                    fontWeight: 500,
                    "&.Mui-focused": {
                      color: "#2563eb",
                    }
                  },
                  "& .MuiSelect-select": {
                    fontWeight: 600,
                    color: "#1e293b",
                  }
                }}
              >
                {domainsList.map((dom) => (
                  <MenuItem key={dom.domain_id || dom.id} value={(dom.domain_id || dom.id).toString()}>
                    {dom.domain_name || dom.name}
                  </MenuItem>
                ))}
              </TextField>

              <Button
                variant="contained"
                disabled={!tempDomain}
                onClick={() => handleDomainSelect(tempDomain)}
                sx={{
                  width: '200px',
                  alignSelf: 'center',
                  py: 1,
                  fontWeight: 'bold',
                  fontSize: '15px',
                  borderRadius: '8px',
                  bgcolor: '#4a90e2',
                  color: 'white',
                  textTransform: 'none',
                  '&:hover': { bgcolor: '#357abd' },
                  '&.Mui-disabled': { bgcolor: '#93c5fd', color: '#ffffff' }
                }}
              >
                Proceed
              </Button>
            </Box>
          ) : (
            <Typography sx={{ textAlign: 'center', color: 'gray', py: 4 }}>No domains found.</Typography>
          )}
        </DialogContent>
      </Dialog>

      {/* 3. Calendar Modal */}
      <Dialog
        open={bookingModalOpen}
        onClose={() => {
          setBookingModalOpen(false);
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: { xs: '12px', sm: '16px' },
            m: { xs: 1, sm: 2 },
            width: { xs: 'calc(100% - 16px)', sm: '520px' },
            maxWidth: '520px',
            position: 'relative',
            overflowX: 'hidden'
          }
        }}
      >
        {cameFromEventModal && (
          <IconButton
            onClick={() => {
              setBookingModalOpen(false);
              setSelectionModalOpen(true);
            }}
            sx={{
              position: 'absolute',
              left: 12,
              top: 12,
              zIndex: 1000,
              bgcolor: 'rgba(255, 255, 255, 0.8)',
              '&:hover': { bgcolor: 'rgba(255, 255, 255, 1)' }
            }}
          >
            <ArrowBack />
          </IconButton>
        )}
        <IconButton
          onClick={() => {
            setBookingModalOpen(false);
          }}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            zIndex: 1000,
            bgcolor: 'rgba(255, 255, 255, 0.8)',
            '&:hover': { bgcolor: 'rgba(255, 255, 255, 1)' }
          }}
        >
          <Close />
        </IconButton>

        <DialogContent sx={{ p: 0 }}>
          <Box>
            <AdvanceBook
              onClose={(isSuccess) => {
                setBookingModalOpen(false);
                if (isSuccess === true) {
                  setRefreshKey(prev => prev + 1);
                }
              }}
              instituteBookings={modalInstituteBookings}
              forcedEventType={
                visibleTabs[value]?.label === "Tech Camp" ? "tech_camp" :
                  visibleTabs[value]?.label === "FDP" ? "fdp" : null
              }
            />
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}






















